export default {
  // Return default colors for form inputs
  inputColors: (color) => {
    switch (color) {
      case 'red':
        return {
          border: 'border-red-300',
          focusBorder: 'focus:ring-red-300 focus:border-red-400',
          buttonBg: 'bg-red-500',
          buttonHoverBg: 'hover:bg-red-600',
        };

      case 'green':
        return {
          border: 'border-green-300',
          focusBorder: 'focus:ring-green-300 focus:border-green-400',
          buttonBg: 'bg-green-500',
          buttonHoverBg: 'hover:bg-green-600',
        };

      case 'gray':
        return {
          border: 'border-gray-300',
          focusBorder: 'focus:ring-gray-300 focus:border-gray-400',
          buttonBg: 'bg-gray-500',
          buttonHoverBg: 'hover:bg-gray-600',
        };

      case 'teal':
        return {
          border: 'border-teal-300',
          focusBorder: 'focus:ring-teal-300 focus:border-teal-400',
          buttonBg: 'bg-teal-500',
          buttonHoverBg: 'hover:bg-teal-600',
        };

      case 'indigo':
        return {
          border: 'border-indigo-300',
          focusBorder: 'focus:ring-indigo-300 focus:border-indigo-700',
          buttonBg: 'bg-indigo-600',
          buttonHoverBg: 'hover:bg-indigo-500',
        };

      case 'purple':
        return {
          border: 'border-purple-300',
          focusBorder: 'focus:ring-purple-300 focus:border-purple-400',
          buttonBg: 'bg-purple-500',
          buttonHoverBg: 'hover:bg-purple-600',
        };
      case 'blue':
      default:
        return {
          border: 'border-blue-300',
          focusBorder: 'focus:ring-blue-300 focus:border-blue-400',
          buttonBg: 'bg-blue-500',
          buttonHoverBg: 'hover:bg-blue-600',
        };
    }
  }
};
